import React from 'react';
import ServiceCategoryPage from './ServiceCategoryPage';

const RecoveryCertificates = () => {
  return (
    <ServiceCategoryPage
      category="Recovery Certificates"
      title="Recovery Certificates"
      intro="Obtain a verifiable medical certificate confirming your recovery from a recent illness. Our UK-based doctors provide same-day certificates for a wide range of conditions."
    />
  );
};

export default RecoveryCertificates;